import { StateCreator } from 'zustand';

export const initialFourEyeApprovalState: boolean = true;

interface OperationBy {
    updatedBy: string;
    actionedBy: string;
}
export interface ConfigurationSlice {
    isFourEyeApproval: boolean;
    setIsFourEyeApproval: (fourEyeData: boolean) => void;
    configStatus: string;
    setConfigStatus: (status: string) => void;
    operationBy: OperationBy;
    setOperationBy: (operationBy: OperationBy) => void;
    externalListAllListCount: number;
    setExternalListAllListCount: (count: number) => void;
    dateFormat: string | null;
    timeFormat: string | null;
    dateTimeFormat: string | null;
    setDateFormats: (dateFormat: string | null, timeFormat: string | null, dateTimeFormat: string | null) => void;
}

export const createConfigurationSlice: StateCreator<ConfigurationSlice, [], [], ConfigurationSlice> = (set) => ({
    isFourEyeApproval: initialFourEyeApprovalState,
    setIsFourEyeApproval: (fourEyeData: boolean) => set(() => ({ isFourEyeApproval: fourEyeData })),
    configStatus: '',
    setConfigStatus: (status) => set({ configStatus: status }),
    operationBy: {
        updatedBy: '',
        actionedBy: ''
    },
    setOperationBy: (operationBy) => set({ operationBy }),
    externalListAllListCount: 0,
    setExternalListAllListCount: (count: number) => set({ externalListAllListCount: count }),
    dateFormat: null,
    timeFormat: null,
    dateTimeFormat: null,
    setDateFormats: (dateFormat: string | null, timeFormat: string | null, dateTimeFormat: string | null) =>
        set({ dateFormat, timeFormat, dateTimeFormat })
});
